module.exports = __webpack_public_path__ + "static/media/nisai.95e2344a.pdf";